import React from 'react';
import {
  Typography,
  Grid,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import ProductCard from '../../../components/ProductCard';
import { products } from '../../../data/products';
import PageLayout from '../../../components/PageLayout';

const PageTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '2.5rem',
  color: '#1a1a1a',
  marginBottom: '1rem',
  textAlign: 'center',
});

const BraceletsPage = () => {
  const braceletProducts = products.filter(product => product.category === 'bracelets');

  return (
    <PageLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <PageTitle>Bracelets</PageTitle>
        <Typography
          variant="subtitle1"
          color="textSecondary"
          align="center"
          sx={{ mb: 6 }}
        >
          Browse our luxurious collection of bracelets, from delicate chains to statement cuffs
        </Typography>

        <Grid container spacing={4}>
          {braceletProducts.map((product) => (
            <Grid item key={product.id} xs={12} sm={6} md={4}>
              <ProductCard product={product} />
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </PageLayout>
  );
};

export default BraceletsPage;
